import { useState } from "react";
import emailjs from "emailjs-com";
import API_BASE_URL from "../config";
import "./Home.css";

export default function Careers() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    role: "Frontend Intern",
    resumeLink: "",
  });

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const sendAutoResponderEmail = async (email, name, role) => {
    try {
      await emailjs.send(
        "service_8gmly32",
        "template_yz591n4",
        {
          to_email: email,
          to_name: name,
          role: role,
        },
        "Ut2RaTlTn5UWRwLOl"
      );
    } catch (error) {
      // Auto-responder failed
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);

    try {
      const response = await fetch(`${API_BASE_URL}/api/careers/apply`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(form),
      });

      if (response.ok) {
        setStatus("success");
        // Optional: Keep auto-responder if you want, or move it to backend
        // await sendAutoResponderEmail(form.email, form.name, form.role); 
        setForm({
          name: "",
          email: "",
          phone: "",
          role: "Frontend Intern",
          resumeLink: "",
        });
      } else {
        setStatus("error");
      }
    } catch (error) {
      setStatus("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gray-50">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white overflow-hidden">
        {/* Decorative Blurs */}
        <div className="absolute top-20 left-10 w-40 h-40 bg-[#4299f5]/20 rounded-full blur-3xl animate-blob"></div>
        <div className="absolute bottom-20 right-10 w-60 h-60 bg-[#4299f5]/20 rounded-full blur-3xl animate-blob animation-delay-2000"></div>
        
        <div className="relative z-10 text-center px-6 pt-32 pb-24 animate-fade-in-up">
          <span className="inline-block px-4 py-2 bg-white/10 backdrop-blur-sm text-white rounded-full font-semibold shadow-lg mb-6 border border-white/20">
            Join Our Team
          </span>
          <h1 className="text-5xl md:text-6xl font-extrabold mb-6 drop-shadow-2xl" style={{fontFamily: 'Montserrat, sans-serif'}}>
            We're Hiring <span className="text-[#4299f5]">Interns!</span>
          </h1>
          <p className="max-w-2xl mx-auto text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed">
            Are you passionate about building, designing, or marketing? Join our
            dynamic team and work on real-world projects that make a difference.
          </p>
          <div className="flex justify-center gap-4 mt-8 animate-fade-in-up delay-200">
            <span className="inline-block px-6 py-3 bg-white/10 backdrop-blur-sm text-white rounded-full font-semibold shadow-xl border border-white/20">
              🏠 Remote & Flexible
            </span>
            <span className="inline-block px-6 py-3 bg-white/10 backdrop-blur-sm text-white rounded-full font-semibold shadow-xl border border-white/20">
              🎓 Certificate & PPO
            </span>
          </div>
        </div>
      </section>

      {/* Form Section */}
      <section className="bg-gray-50 py-16 px-4">
      <div className="max-w-xl mx-auto bg-white p-10 rounded-2xl shadow-xl border-2 border-transparent hover:border-[#4299f5] transition-all duration-300 animate-fade-in-up delay-300">
        <h2 className="text-3xl font-bold mb-6 text-center text-gray-900" style={{fontFamily: 'Montserrat, sans-serif'}}>
          Apply Now
        </h2>

        {status === "success" && (
          <p className="mb-4 text-green-600 text-center font-medium">
            ✅ Application submitted successfully! We'll contact you soon.
          </p>
        )}
        {status === "error" && (
          <p className="mb-4 text-red-600 text-center font-medium">
            ❌ Something went wrong. Please try again.
          </p>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Full Name */}
          <div>
            <label
              htmlFor="name"
              className="block font-semibold mb-2 text-gray-900"
            >
              Full Name
            </label>
            <input
              name="name"
              id="name"
              type="text"
              placeholder="Enter your name"
              value={form.name}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 rounded-lg border border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#4299f5] focus:border-transparent text-gray-900"
            />
          </div>

          {/* Email */}
          <div>
            <label
              htmlFor="email"
              className="block font-semibold mb-2 text-gray-900"
            >
              Email Address
            </label>
            <input
              name="email"
              id="email"
              type="email"
              placeholder="you@example.com"
              value={form.email}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 rounded-lg border border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#4299f5] focus:border-transparent text-gray-900"
            />
          </div>

          {/* Phone */}
          <div>
            <label
              htmlFor="phone"
              className="block font-semibold mb-2 text-gray-900"
            >
              Phone Number
            </label>
            <input
              name="phone"
              id="phone"
              type="tel"
              placeholder="9876543210"
              pattern="[0-9]{10}"
              maxLength="10"
              value={form.phone}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 rounded-lg border border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#4299f5] focus:border-transparent text-gray-900"
            />
          </div>

          {/* Role */}
          <div>
            <label
              htmlFor="role"
              className="block font-semibold mb-2 text-gray-900"
            >
              Role You're Applying For
            </label>
            <select
              name="role"
              id="role"
              value={form.role}
              onChange={handleChange}
              className="w-full px-4 py-2 rounded-lg border border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#4299f5] focus:border-transparent text-gray-900"
            >
              <option value="Frontend Intern">Frontend Intern</option>
              <option value="Backend Intern">Backend Intern</option>
              <option value="UI/UX Designer">UI/UX Designer</option>
              <option value="Marketing Intern">Marketing Intern</option>
              <option value="Full-Stack Intern">Full-Stack Intern</option>
              <option value="ML Intern">ML Intern</option>
              <option value="AI Intern">AI Intern</option>
              <option value="Sales Intern">Sales Intern</option>
            </select>
          </div>

          {/* Resume Link */}
          <div>
            <label
              htmlFor="resumeLink"
              className="block font-semibold mb-2 text-gray-900"
            >
              Resume Link (Google Drive / Dropbox)
            </label>
            <input
              name="resumeLink"
              id="resumeLink"
              type="url"
              placeholder="https://drive.google.com/your-resume-link"
              value={form.resumeLink}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 rounded-lg border border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#4299f5] focus:border-transparent text-gray-900"
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className={`w-full ${
              loading ? "bg-gray-400" : "bg-[#4299f5] hover:bg-[#3a8fe5]"
            } text-white py-3 rounded-lg font-semibold shadow-lg transition-all duration-300 transform hover:scale-105`}
            style={{fontFamily: 'Montserrat, sans-serif'}}
          >
            {loading ? "Submitting..." : "Apply Now"}
          </button>
        </form>
      </div>
      </section>
    </div>
  );
}
